import React from 'react';
import { inject, observer } from 'mobx-react';
import styles from './index.module.scss';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';
import Avatar from '@components/avatar';
import { BASE_IMG_URL } from '@images/imageUrls';
import classNames from 'classnames';
import { formatTime } from '@utils/timeUtils';
import { withRouter } from 'react-router-dom';
import { BaseComponent } from '@components/Base/h5/BaseComponent';
import type { BaseRouteComponentProps } from '../../../types/base';
import { Image } from 'antd';
import InfiniteScrollList from '@components/InfiniteScrollList';
import updateImageListSrc from "@utils/update-image-list-src";
import parse, { domToReact } from 'html-react-parser';

interface H5SystemListProps extends BaseRouteComponentProps {
    app?: AppStore;
    site?: SiteStore;
    user?: UserAction;
    data: any;
    loading?: boolean;
    hasMore?: boolean;
    onLoadMore?: () => void;
    itemClick?: Function;
    emptyText?: string; // 为空时提示文字
    emptyIcon?: string; // 为空时icon
    emptyBoxStyle?: any; // 为空状态时的自定义样式
}

@inject('app', 'site', 'user')
@observer
class H5SystemList extends BaseComponent<H5SystemListProps> {
    componentDidMount() {
        // 可以在这里添加初始化逻辑
        console.log('这里是H5');
    }
    // 渲染单个列表项
    renderItem = (item: any, index: number) => {
        const { itemClick } = this.props;
        // console.log(showRecommendUserList, '是否显示推荐关注列表', recommendUserList)
        let options = {};
        const parserOptions = {
            replace: (domNode: any) => {
                // 可以在这里自定义节点替换逻辑
            },
            ...options
        };
        return (
            <React.Fragment key={item.id || item._id || index}>
                <div className={styles.itemTime}>{item.createdAt}</div>
                <div className={styles.item} key={item.data.id || item.data._id} onClick={() => {
                    itemClick && itemClick(item)
                }}>
                    <div className={styles.itemTitleBox}>
                        <div className={classNames(styles.itemTitle, !item.readAt ? styles.noRead : '')}>{item.data?.title}</div>
                        
                    </div>
                    <div className={styles.itemContent}>{item.data?.content}</div>
                </div>
            </React.Fragment>
        );
    };

    renderContent() {
        const { data, loading = false, hasMore = true, emptyText, emptyIcon, emptyBoxStyle, onLoadMore } = this.props;

        if (!Array.isArray(data)) return null;

        return (
            <div className={styles.listBox}>
                <InfiniteScrollList
                    variant="h5"
                    data={data}
                    loading={loading}
                    hasMore={hasMore}
                    onLoadMore={onLoadMore || (() => { })}
                    renderItem={(item, index) => this.renderItem(item, index)}
                    threshold={100}
                    emptyText={emptyText || '这里是空的'}
                    emptyIcon={emptyIcon}
                    emptyBoxStyle={emptyBoxStyle}
                    loadingText="加载中..."
                    noMoreText="没有更多帖子了"
                />
            </div>
        );
    }
}

export default withRouter(H5SystemList);